import React, { useEffect, useState } from 'react';
import axios from 'axios';

const VideoGallery = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/videos`);
        console.log(response.data); // Check if thumbnailUrl is in the data
        setVideos(response.data);
      } catch (error) {
        console.error('Error fetching videos:', error);
      }
    };
  
    fetchVideos();
  }, []);
  
  return (
    <div className="flex flex-wrap justify-center gap-8 p-4 ">
      {videos.map(video => (
        <div
          key={video._id}
          className="max-w-xs  bg-white shadow-md rounded-lg overflow-hidden transition-transform transform hover:scale-105"
        >
          <img
            src={video.thumbnailUrl}
            alt={video.title}
            className="w-full h-48 object-cover"
          />
          <div className="p-16 text-center">
           <h3 className="text-lg font-semibold"> Speaker : {video.title}</h3>
            <h3 className="text-lg font-semibold">Date : {video.title}</h3>
            <h3 className="text-lg font-semibold">{video.title}</h3>

            <a
              href={video.videoUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 mt-2 inline-block hover:underline"
            >
              Watch on YouTube
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VideoGallery;
